
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Adicione à Tela de Início para uma melhor experiência e mais fácil acesso.`,
's224cbcec014ef6b5': `Pressione Compartilhar na barra de endereço`,
's37a9e8aec5713460': `Mais`,
's386eca8362ff6155': `Pressione Mais se não houver ícone de Compartilhar`,
's4e1e10a6ca408245': `Toque em "Adicionar à Tela de Início"`,
's6196153c4b0c1ea0': `Instalar`,
's633502f7cff4f847': `Abra o menu do seu navegador`,
's681e399d63311fba': `Mostrar Galeria`,
's7f0591f08e318eda': `Pressione Mais no menu de Compartilhar`,
's8114bd55cae5a22b': `Pressione Adicionar ao Dock`,
's922329d6f6213590': `Adicionar ao Dock`,
's9af56bf005b49c74': `Role para baixo até "Adicionar à Tela de Início"`,
'sa5ef80b4bb9b39f8': `Menos`,
'sba52286c21552a4e': `Instale no dispositivo para uma melhor experiência e mais fácil acesso.`,
'sc16e00a7a8b2fde2': `Voltar`,
'scdaf4bbff76674c8': `Adicionar à Tela de Início`,
'se0e473adfda8066c': `Abra no seu navegador principal`,
'se740f75b95a51807': `Adicione ao Dock para uma melhor experiência e mais fácil acesso.`,
'sfea652f6580ff086': `Este site possui funcionalidade de aplicativo.`,
    };
  